import _ from 'lodash';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import LoadingSpinner from '../../../../components/LoadingSpinner';
import CashAdvanceRequestForm from './CashAdvanceRequestForm';
import { getEmployees } from '../../../../actions/HumanResources/employeeActions';
import { createCashAdvanceRequest } from '../../../../actions/HumanResources/cashAdvanceRequestActions';

const CashAdvanceRequestCreate = (props) => {
	const { datas, loading } = props;
	useEffect(() => {
		props.getEmployees();
	}, []);
	const onSubmit = (formValues) => {
		if (!_.isEmpty(formValues)) {
			props.createCashAdvanceRequest(formValues);
		}
	};
	return (
		<>
			{loading ? (
				<LoadingSpinner />
			) : (
				<div className="mt-3">
					<CashAdvanceRequestForm datas={datas} onSubmit={onSubmit} />
				</div>
			)}
		</>
	);
};
const mapStateToProps = (state) => {
	const {
		humanResources: {
			employee: { employees, getEmployeesLoading },
		},
	} = state;
	return { datas: { employees }, loading: getEmployeesLoading };
};
export default connect(mapStateToProps, { getEmployees, createCashAdvanceRequest })(CashAdvanceRequestCreate);
